import { popoverAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';

// eslint-disable-next-line @typescript-eslint/unbound-method
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

const sltTooltip = definePartsStyle({
    popper: defineStyle({
        zIndex: '1500 !important',
    }),
    content: defineStyle({
        bg: 'var(--tooltip-bg)',
        '--popper-arrow-bg': 'var(--tooltip-bg)',
        maxW: '280px',
        '--tooltip-bg': 'white',
        color: 'slt-black.900',
        borderColor: 'white',
        borderRadius: '2px',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)',
        marginTop: 1,
        marginBottom: 2,
        padding: 2,
        _focusVisible: {
            boxShadow: 'unset',
        },
    }),
    body: defineStyle({
        textStyle: 'slt-body-text',
    }),
});

const sltPopover = definePartsStyle({
    popper: defineStyle({
        zIndex: '1500 !important',
    }),
    content: defineStyle({
        width: '375px',
        borderColor: 'white',
        borderRadius: { base: 0, sm: 16 },
        boxShadow: '0px 2px 10px 0px rgba(65, 64, 66, 0.14)',
        _focusVisible: {
            boxShadow: '0px 2px 10px 0px rgba(65, 64, 66, 0.14)',
        },
    }),
    header: defineStyle({
        textStyle: 'body-large-2',
        backgroundColor: 'white',
        border: 'none',
        padding: 4,
        borderTopRadius: { base: 0, sm: 16 },
    }),
    body: defineStyle({
        textStyle: 'body-base',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        paddingTop: 0,
        paddingBottom: 4,
        paddingX: 0,
        overflowY: 'auto',
        maxHeight: '70vh',
    }),
});

const sltOutline = {
    ...sltPopover,
    popper: defineStyle({
        display: 'flex',
        justifyContent: 'center',
        zIndex: '1500 !important',
        width: { base: '100vw', md: '100%' },
        minWidth: 'unset !important',
    }),
    content: defineStyle({
        ...sltPopover.content,
        width: '100%',
        maxHeight: { md: '80vh' },
        maxWidth: { md: 'calc(100vw - 64px)', xl: 'calc(100vw - 128px)' },
        margin: 0,
        padding: 0,
        boxShadow: 'none',
        borderColor: 'slt-pepper.300',
        borderWidth: { base: 0, md: 1 },
        borderRadius: { base: 0, md: 8 },
        top: { base: 2, md: 0 },

        _focusVisible: {
            boxShadow: 'none',
        },
    }),
    body: defineStyle({
        ...sltPopover.body,
        maxHeight: 'unset',
        padding: 0,
        overscrollBehavior: 'contain',
        overflow: 'auto',
    }),
};

export const Popover = defineMultiStyleConfig({
    variants: {
        'slt-popover': sltPopover,
        'slt-tooltip': sltTooltip,
        'slt-outline': sltOutline,
    },
    defaultProps: {
        variant: 'slt-popover',
    },
});
